import {
    ChangePaymentTypeAction,
    UpdateCardPaymentActionStart,
    UpdateCardPaymentActionSuccess,
    UpdateCardPaymentActionError,
    UpdateCardPaymentAction,
    ChangePaymentTypeActionStart,
    ChangePaymentTypeActionSuccess,
    ChangePaymentTypeActionError,
    UpdateIfcPaymentAction,
    UpdateIfcPaymentActionStart,
    UpdateIfcPaymentActionSuccess,
    UpdateIfcPaymentActionError,
    RemoveCardPaymentErrorMessageAction,
    LoadPaymentAction,
    LoadPaymentActionStart,
    LoadPaymentActionSuccess,
    LoadPaymentActionError,
    InitializePaymentCalculatorAction,
    InitializePaymentCalculatorActionStart,
    InitializePaymentCalculatorActionSuccess,
    InitializePaymentCalculatorActionError,
    RemovePaymentResultAction,
    CreatePaymentSessionAction,
    CreatePaymentSessionActionStart,
    CreatePaymentSessionActionSuccess,
    CreatePaymentSessionActionError,
    CardPaymentRejectAction,
    CardPaymentCompleteAction,
    CardPaymentCompleteActionStart,
    CardPaymentCompleteActionSuccess,
    CardPaymentCompleteActionError,
    CardPaymentRejectSuccessAction
} from './actions';
import {
    PaypalSuccessfulPaymentResponseModel,
    CardSuccessfulPaymentResponseModel,
    PaypalAuthModel,
    IfcPaymentStateModel,
    PaymentDetailsModel,
    CardPaymentStateModel,
    PaymentSessionModel
} from 'models/Payment';
import {
    PaypalSetupPaymentAction,
    PaypalSetupPaymentActionStart,
    PaypalSetupPaymentActionSuccess,
    PaypalSetupPaymentActionError,
    PaypalPaymentActionStart,
    PaypalPaymentActionSuccess,
    PaypalPaymentActionError,
    PaypalSetAuthResultAction,
    PaypalRejectAction,
    PaypalCompletePaymentAction,
    PaypalCompletePaymentActionStart,
    PaypalCompletePaymentActionSuccess,
    PaypalCompletePaymentActionError,
    RemovePaypalPaymentErrorMessageAction
} from './actions/paypal';
import { BasketErrorModel } from 'models/Errors';

import { InitFirstFinanceApplicationPageAction } from 'store/checkout/actions/finance';
import { ValidateBeforePaymentActionError, ValidateBeforePaymentActionStart, ValidateBeforePaymentActionSuccess } from './actions/validateBeforePayment';

export enum PaymentActionTypes {
    CHANGE_PAYMENT_TYPE = 'payment/CHANGE_PAYMENT_TYPE',
    CHANGE_PAYMENT_TYPE_START = 'payment/CHANGE_PAYMENT_TYPE_START',
    CHANGE_PAYMENT_TYPE_SUCCESS = 'payment/CHANGE_PAYMENT_TYPE_SUCCESS',
    CHANGE_PAYMENT_TYPE_ERROR = 'payment/CHANGE_PAYMENT_TYPE_ERROR',

    INITIALIZE_PAYMENT_CALCULATOR = 'payment/INITIALIZE_PAYMENT_CALCULATOR',
    INITIALIZE_PAYMENT_CALCULATOR_START = 'payment/INITIALIZE_PAYMENT_CALCULATOR_START',
    INITIALIZE_PAYMENT_CALCULATOR_SUCCESS = 'payment/INITIALIZE_PAYMENT_CALCULATOR_SUCCESS',
    INITIALIZE_PAYMENT_CALCULATOR_ERROR = 'payment/INITIALIZE_PAYMENT_CALCULATOR_ERROR',

    LOAD_PAYMENT = 'payment/LOAD_PAYMENT',
    LOAD_PAYMENT_START = 'payment/LOAD_PAYMENT_START',
    LOAD_PAYMENT_SUCCESS = 'payment/LOAD_PAYMENT_SUCCESS',
    LOAD_PAYMENT_ERROR = 'payment/LOAD_PAYMENT_ERROR',

    UPDATE_CARD_PAYMENT = 'payment/UPDATE_CARD_PAYMENT',
    UPDATE_CARD_PAYMENT_START = 'payment/UPDATE_CARD_PAYMENT_START',
    UPDATE_CARD_PAYMENT_SUCCESS = 'payment/UPDATE_CARD_PAYMENT_SUCCESS',
    UPDATE_CARD_PAYMENT_ERROR = 'payment/UPDATE_CARD_PAYMENT_ERROR',

    UPDATE_IFC_PAYMENT = 'payment/UPDATE_IFC_PAYMENT',
    UPDATE_IFC_PAYMENT_START = 'payment/UPDATE_IFC_PAYMENT_START',
    UPDATE_IFC_PAYMENT_SUCCESS = 'payment/UPDATE_IFC_PAYMENT_SUCCESS',
    UPDATE_IFC_PAYMENT_ERROR = 'payment/UPDATE_IFC_PAYMENT_ERROR',

    CARD_PAYMENT_REJECT = 'payment/CARD_PAYMENT_REJECT',
    CARD_PAYMENT_REJECT_SUCCESS = 'payment/CARD_PAYMENT_REJECT_SUCCESS',

    CARD_PAYMENT_COMPLETE = 'payment/CARD_PAYMENT_COMPLETE',
    CARD_PAYMENT_COMPLETE_START = 'payment/CARD_PAYMENT_COMPLETE_START',
    CARD_PAYMENT_COMPLETE_SUCCESS = 'payment/CARD_PAYMENT_COMPLETE_SUCCESS',
    CARD_PAYMENT_COMPLETE_ERROR = 'payment/CARD_PAYMENT_COMPLETE_ERROR',

    REMOVE_CARD_PAYMENT_ERROR_MESSAGE = 'payment/REMOVE_CARD_PAYMENT_ERROR_MESSAGE',

    REMOVE_PAYMENT_RESULT = 'payment/REMOVE_PAYMENT_RESULT',

    PAYPAL_SETUP_PAYMENT = 'payment/PAYPAL_SETUP_PAYMENT',
    PAYPAL_SETUP_PAYMENT_START = 'payment/PAYPAL_SETUP_PAYMENT_START',
    PAYPAL_SETUP_PAYMENT_SUCCESS = 'payment/PAYPAL_SETUP_PAYMENT_SUCCESS',
    PAYPAL_SETUP_PAYMENT_ERROR = 'payment/PAYPAL_SETUP_PAYMENT_ERROR',

    PAYPAL_PAYMENT_START = 'payment/PAYPAL_PAYMENT_START',
    PAYPAL_PAYMENT_SUCCESS = 'payment/PAYPAL_PAYMENT_SUCCESS',
    PAYPAL_PAYMENT_ERROR = 'payment/PAYPAL_PAYMENT_ERROR',

    PAYPAL_SET_AUTH_RESULT = 'payment/PAYPAL_SET_AUTH_RESULT',
    PAYPAL_REJECT = 'payment/PAYPAL_REJECT',

    PAYPAL_COMPLETE_PAYMENT = 'payment/PAYPAL_COMPLETE_PAYMENT',
    PAYPAL_COMPLETE_PAYMENT_START = 'payment/PAYPAL_COMPLETE_PAYMENT_START',
    PAYPAL_COMPLETE_PAYMENT_SUCCESS = 'payment/PAYPAL_COMPLETE_PAYMENT_SUCCESS',
    PAYPAL_COMPLETE_PAYMENT_ERROR = 'payment/PAYPAL_COMPLETE_PAYMENT_ERROR',

    REMOVE_PAYPAL_PAYMENT_ERROR_MESSAGE = 'payment/REMOVE_PAYPAL_PAYMENT_ERROR_MESSAGE',

    CREATE_PAYMENT_SESSION = 'payment/CREATE_PAYMENT_SESSION',
    CREATE_PAYMENT_SESSION_START = 'payment/CREATE_PAYMENT_SESSION_START',
    CREATE_PAYMENT_SESSION_SUCCESS = 'payment/CREATE_PAYMENT_SESSION_SUCCESS',
    CREATE_PAYMENT_SESSION_ERROR = 'payment/CREATE_PAYMENT_SESSION_ERROR',

    VALIDATE_BEFORE_PAYMENT = 'payment/VALIDATE_BEFORE_PAYMENT',
    VALIDATE_BEFORE_PAYMENT_START = 'payment/VALIDATE_BEFORE_PAYMENT_START',
    VALIDATE_BEFORE_PAYMENT_SUCCESS = 'payment/VALIDATE_BEFORE_PAYMENT_SUCCESS',
    VALIDATE_BEFORE_PAYMENT_ERROR = 'payment/VALIDATE_BEFORE_PAYMENT_ERROR'
}

export interface PaymentState {
    isPaymentLoading: boolean;
    isPaymentCalculatorInitializing: boolean;
    paymentDetails: PaymentDetailsModel;
    cardPaymentState: CardPaymentStateModel | null;
    ifcPaymentState: IfcPaymentStateModel | null;
    isPaymentUpdating: boolean;
    isPaymentTypeUpdating: boolean;
    isCardPaymentProcessing: boolean;
    cardPaymentError: BasketErrorModel | null;
    paymentSuccessfullyCompleted: boolean;
    successfulPaymentResult: CardSuccessfulPaymentResponseModel | PaypalSuccessfulPaymentResponseModel | null;
    isPaypalPaymentProcessing: boolean;
    isPaypalPaymentSetupInProgress: boolean;
    paypalPaymentCode: string | null;
    paypalPaymentError: BasketErrorModel | null;
    paypalAuthSuccessfullResult: PaypalAuthModel | null;
    isPaypalPaymentCompleteProcessing: boolean;
    isIfcFormSubmitted: boolean;
    paymentSession: PaymentSessionModel | null;
    isPaymentSessionLoading: boolean;
}

export type PaymentActions =
    ChangePaymentTypeAction

    | InitFirstFinanceApplicationPageAction

    | InitializePaymentCalculatorAction
    | InitializePaymentCalculatorActionStart
    | InitializePaymentCalculatorActionSuccess
    | InitializePaymentCalculatorActionError

    | LoadPaymentAction
    | LoadPaymentActionStart
    | LoadPaymentActionSuccess
    | LoadPaymentActionError

    | UpdateCardPaymentAction
    | UpdateCardPaymentActionStart
    | UpdateCardPaymentActionSuccess
    | UpdateCardPaymentActionError

    | UpdateIfcPaymentAction
    | UpdateIfcPaymentActionStart
    | UpdateIfcPaymentActionSuccess
    | UpdateIfcPaymentActionError

    | ChangePaymentTypeAction
    | ChangePaymentTypeActionStart
    | ChangePaymentTypeActionSuccess
    | ChangePaymentTypeActionError

    | CardPaymentRejectAction
    | CardPaymentRejectSuccessAction

    | CardPaymentCompleteAction
    | CardPaymentCompleteActionStart
    | CardPaymentCompleteActionSuccess
    | CardPaymentCompleteActionError

    | RemoveCardPaymentErrorMessageAction

    | RemovePaymentResultAction

    | PaypalPaymentActionStart
    | PaypalPaymentActionSuccess
    | PaypalPaymentActionError

    | PaypalSetupPaymentAction
    | PaypalSetupPaymentActionStart
    | PaypalSetupPaymentActionSuccess
    | PaypalSetupPaymentActionError

    | PaypalSetAuthResultAction

    | PaypalRejectAction

    | PaypalCompletePaymentAction
    | PaypalCompletePaymentActionStart
    | PaypalCompletePaymentActionSuccess
    | PaypalCompletePaymentActionError

    | RemovePaypalPaymentErrorMessageAction

    | CreatePaymentSessionAction
    | CreatePaymentSessionActionStart
    | CreatePaymentSessionActionSuccess
    | CreatePaymentSessionActionError

    | ValidateBeforePaymentActionStart
    | ValidateBeforePaymentActionSuccess
    | ValidateBeforePaymentActionError;